import React, { Component } from "react";
import Select from "../../select";

class RatingSelect extends Component<{
	country: string;
	onRatingChange: any;
	rating: any;
	ratings: Array<any>;
	disabled?: boolean;
}> {
	render() {
		return (
			<Select
				prompt={null}
				value={this.props.rating}
				items={this.props.ratings}
				onChange={this.props.onRatingChange}
				disabled={this.props.disabled}
			/>
		);
	}
}

export default RatingSelect;
